// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — alert-enable.styled.classic.js, новая — alert-enable.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './alert-enable.styled.classic';
import * as cp from './alert-enable.styled.cp';

export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const WrapMessage = isCp ? cp.WrapMessage : classic.WrapMessage;
